const isWalletNoise = (event) => {
  const reason = (event && (event.reason || event.error)) || event;
  const text = [
    reason && reason.message,
    reason && reason.stack,
    String(reason || ""),
    event && event.filename,
  ]
    .filter(Boolean)
    .join(" ");
  return /MetaMask|Failed to connect to MetaMask|chrome-extension:\/\/nkbihfbeogaeaoehlefnkodbefgpgknn/i.test(
    text
  );
};

const mute = (event) => {
  if (!isWalletNoise(event)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
};

window.addEventListener("unhandledrejection", mute, true);
window.addEventListener("error", mute, true);
